<rep-data-view-toolbar
  [reportData]="reportData()"
  [isUKFeaturesEnabled]="isUKFeaturesEnabled()"
  (customizeColumns)="customizeColumns.emit($event)"
></rep-data-view-toolbar>
<rep-data-view-table
  [reportData]="reportData()"
  [displayedColumns]="displayedColumns()"
  [reportLocale]="reportLocale()"
  [defaultColumns]="defaultColumns()"
  [templateProjectionMap]="templateProjectionMap()"
  (reportReordered)="reportReordered.emit($event)"
  (removeRecord)="removeRecordFromReport($event)"
  (reportUpdateClick)="reportUpdateClick.emit($event)"
  (reorderReportColumns)="reorderReportColumns.emit($event)"
></rep-data-view-table>
